import { getRawPalette } from '../selectors/getRawPalette';

export const setCssVariablesOnDocument = (): void => {
    const themePalette = getRawPalette();

    // Even if a browser doesn't support CSS variables, setting these values is benign
    Object.keys(themePalette).forEach(key =>
        document.documentElement.style.setProperty(`--${key}`, themePalette[key])
    );
};
